// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%236b7280%27 d=%27M6 8L1 3h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Shell (centered modal) ─── */
.rpm-drawer-paper {
  width: 80vw;
  background: transparent !important;
  box-shadow: none !important;
  overflow: visible !important;
  border-radius: 0 !important;
  z-index: 2001;
}

.rpm-shell {
  position: relative;
  width: 100%;
  height: 100vh;
  margin: 0;
  background: #ffffff;
  border-radius: 0;
  box-shadow: -4px 0 32px rgba(15, 23, 42, 0.18);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: rpmFadeIn 180ms ease-out;
}

/* ─── Header ─── */
.rpm-header {
  padding: 18px 24px 14px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.rpm-header-left h3 {
  margin: 0;
  font-size: 22px !important;
  font-weight: 700;
  color: #101828;
  line-height: 1.2;
}

.rpm-header-left p {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 13px !important;
}

.rpm-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rpm-bill-summary-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #fff;
  color: #334155;
  font-size: 14px !important;
  font-weight: 600;
  padding: 0 14px;
  cursor: pointer;
  height: 44px;
  white-space: nowrap;
  transition: all 0.15s;
}

.rpm-bill-summary-btn:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

/* ─── Extras top section ─── */
.rpm-extras-top {
  padding: 12px 24px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.rpm-extras-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  white-space: nowrap;
  padding: 0 14px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #334155;
  font-size: 14px !important;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.rpm-extras-toggle-btn:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.rpm-manual-charges {
  margin-top: 0;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  background: #fafafa;
}

.rpm-charges-apply-row {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 14px;
}

.rpm-charges-cancel-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 20px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #334155;
  font-size: 13px !important;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.rpm-charges-cancel-btn:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.rpm-charges-cancel-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.rpm-charges-apply-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 20px;
  border-radius: 8px;
  border: 0;
  background: #2563eb;
  color: #fff;
  font-size: 13px !important;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.rpm-charges-apply-btn:hover {
  background: #1d4ed8;
}

.rpm-charges-apply-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.rpm-manual-charges-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 14px;
  gap: 16px;
}

.rpm-manual-charges-title {
  font-size: 11px !important;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  display: block;
  margin-bottom: 4px;
}

.rpm-manual-charges-info p {
  margin: 0;
  font-size: 12px !important;
  color: #6b7280;
}

.rpm-charges-total-badge {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 6px 12px;
  text-align: right;
  background: #fff;
  flex-shrink: 0;
}

.rpm-charges-total-badge span {
  display: block;
  font-size: 10px !important;
  font-weight: 700;
  color: #2563eb;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.rpm-charges-total-value {
  font-size: 18px !important;
  font-weight: 700;
  color: #2563eb;
  display: block;
}

.rpm-manual-charges-fields {
  display: flex;
  gap: 16px;
}

.rpm-charge-field {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rpm-charge-field label {
  font-size: 13px !important;
  color: #374151;
  font-weight: 500;
}

.rpm-charge-input-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  position: relative;
}

.rpm-charge-input {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px !important;
  color: #111827;
  outline: none;
  background: #fff;
}

.rpm-charge-input:focus {
  border-color: #3b82f6;
}

.rpm-charge-input::-webkit-outer-spin-button,
.rpm-charge-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

/* ─── Payment Methods (horizontal cards) ─── */
.rpm-methods-section {
  padding: 14px 24px 10px;
  flex-shrink: 0;
  border-bottom: 1px solid #e5e7eb;
}

.rpm-methods-label {
  font-size: 11px !important;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 10px;
  display: block;
}

.rpm-methods-row {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.rpm-methods-row::-webkit-scrollbar {
  height: 3px;
}

.rpm-methods-row::-webkit-scrollbar-thumb {
  background: #e5e7eb;
  border-radius: 2px;
}

.rpm-method-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 88px;
  padding: 12px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  font-size: 12px !important;
  font-weight: 500;
  color: #374151;
  flex-shrink: 0;
  transition:
    background 0.12s,
    border-color 0.12s,
    color 0.12s;
}

.rpm-method-card.active {
  background: #111827;
  border-color: #111827;
  color: #ffffff;
}

.rpm-method-card:hover:not(.active) {
  background: #f3f4f6;
}

/* ─── Body (normal mode, two columns) ─── */
.rpm-body {
  display: grid;
  grid-template-columns: 46% 54%;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

/* ─── Active Tender panel (left) ─── */
.rpm-tender-panel {
  padding: 20px;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #fafbfc;
  overflow-y: auto;
}

.rpm-tender-label {
  font-size: 11px !important;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.rpm-tender-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.rpm-tender-name {
  margin: 0;
  font-size: 28px !important;
  font-weight: 700;
  color: #111827;
}

.rpm-terminal-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: #ecfdf5;
  border: 1px solid #6ee7b7;
  border-radius: 999px;
  font-size: 11px !important;
  font-weight: 700;
  color: #065f46;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.rpm-terminal-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #10b981;
  display: inline-block;
  flex-shrink: 0;
}

.rpm-tender-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.rpm-stat-box {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rpm-stat-label {
  font-size: 10px !important;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.rpm-stat-value {
  font-size: 17px !important;
  font-weight: 700;
  color: #111827;
}

.rpm-remaining-red {
  color: #dc2626 !important;
}

.rpm-settlement-card {
  border: 1px solid #e2e8f0;
  border-radius: 24px;
  padding: 20px;
  background: #f8fafc;
  transition: all 0.15s ease-in-out;
  display: flex;
  flex-direction: column;
  margin-top: auto;
}

.rpm-settlement-card-change {
  border-color: #a4f4cf;
  background: #ecfdf5;
}

.rpm-settlement-card-change .rpm-settlement-label {
  color: #007a55;
}

.rpm-settlement-card-change .rpm-settlement-amount {
  color: #007a55;
}

.rpm-settlement-label {
  font-size: 11px !important;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8;
  margin: 0;
}

.rpm-settlement-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.rpm-settlement-text {
  font-size: 13px !important;
  color: #6b7280;
  display: block;
  margin-top: 4px;
}

.rpm-settlement-amount {
  font-size: 30px !important;
  font-weight: 700;
  color: #94a3b8;
  white-space: nowrap;
}

/* ─── Action panel (right) ─── */
.rpm-action-panel {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow-y: auto;
  background: #fff;
}

/* Cash input */
.rpm-cash-label {
  font-size: 13px !important;
  font-weight: 500;
  color: #374151;
  display: block;
}

.rpm-cash-input-wrapper {
  display: flex;
  align-items: center;
  border: 2px solid #3b82f6;
  border-radius: 10px;
  padding: 0 14px;
  background: #fff;
  height: 54px;
}

.rpm-cash-currency {
  font-size: 20px !important;
  color: #374151;
  margin-right: 8px;
  font-weight: 500;
}

.rpm-cash-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 22px !important;
  font-weight: 600;
  color: #111827;
  background: transparent;
  width: 100%;
}

.rpm-cash-input::-webkit-inner-spin-button,
.rpm-cash-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.rpm-quick-chips {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.rpm-quick-chip {
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #fff;
  color: #374151;
  font-size: 13px !important;
  font-weight: 500;
  padding: 6px 14px;
  cursor: pointer;
  transition: background 0.1s;
}

.rpm-quick-chip:hover {
  background: #f3f4f6;
}

.rpm-exact-chip {
  border-color: #3b82f6;
  color: #2563eb;
  font-weight: 600;
}

.rpm-exact-chip:hover {
  background: #eff6ff;
}

/* Ready to process (card / upi) */
.rpm-ready-panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.rpm-ready-label {
  font-size: 11px !important;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.rpm-ready-method-name {
  font-size: 26px !important;
  font-weight: 700;
  color: #111827;
}

.rpm-ready-amount-box {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  background: #f9fafb;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rpm-ready-amount-label {
  font-size: 10px !important;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.rpm-ready-amount-value {
  font-size: 26px !important;
  font-weight: 700;
  color: #111827;
}

.rpm-ready-desc {
  margin: 0;
  font-size: 13px !important;
  color: #6b7280;
}

/* ─── Split mode ─── */
.rpm-split-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.rpm-split-mode-tabs {
  display: flex;
  padding: 12px 20px 0;
  gap: 8px;
  flex-shrink: 0;
}

.rpm-split-mode-tab {
  padding: 10px 20px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #fff;
  font-size: 14px !important;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: background 0.12s;
}

.rpm-split-mode-tab.active {
  background: #111827;
  border-color: #111827;
  color: #fff;
  font-weight: 600;
}

.rpm-split-cancel-btn {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  background: #fff5f5;
  color: #b91c1c;
  font-size: 13px !important;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.12s;
}

.rpm-split-cancel-btn:hover:not(:disabled) {
  background: #fee2e2;
}

.rpm-split-cancel-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.rpm-split-panels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 12px 20px 0;
  gap: 12px;
}

.rpm-split-captured-panel {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
}

.rpm-split-captured-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.rpm-split-captured-info strong {
  font-size: 15px !important;
  color: #111827;
  display: block;
}

.rpm-split-captured-info p {
  margin: 4px 0 0;
  font-size: 12px !important;
  color: #6b7280;
}

.rpm-split-count {
  text-align: right;
  flex-shrink: 0;
}

.rpm-split-count-num {
  display: block;
  font-size: 22px !important;
  font-weight: 700;
  color: #111827;
}

.rpm-split-count-label {
  font-size: 10px !important;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.rpm-split-captured-body {
  flex: 1;
}

.rpm-split-empty-msg {
  font-size: 13px !important;
  color: #6b7280;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  padding: 20px 16px;
  text-align: center;
  margin: 0;
}

.rpm-split-payment-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px !important;
  font-weight: 600;
  color: #111827;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.rpm-split-next-panel {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow-y: auto;
}

.rpm-split-next-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
}

.rpm-split-next-info strong {
  font-size: 15px !important;
  color: #111827;
  display: block;
}

.rpm-split-next-info p {
  margin: 4px 0 0;
  font-size: 12px !important;
  color: #6b7280;
}

.rpm-use-remaining-btn {
  flex-shrink: 0;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  color: #374151;
  font-size: 11px !important;
  font-weight: 700;
  padding: 6px 10px;
  cursor: pointer;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.rpm-use-remaining-btn:hover {
  background: #f3f4f6;
}

.rpm-split-next-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.rpm-split-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rpm-split-field label {
  font-size: 12px !important;
  font-weight: 600;
  color: #374151;
}

.rpm-split-select {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 9px 30px 9px 12px;
  font-size: 13px !important;
  color: #111827;
  background: #fff;
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  width: 100%;
}

.rpm-split-select:focus {
  border-color: #3b82f6;
}

.rpm-split-amount-input {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 14px !important;
  font-weight: 600;
  color: #111827;
  background: #fff;
  outline: none;
  width: 100%;
}

.rpm-split-amount-input:focus {
  border-color: #3b82f6;
}

.rpm-split-amount-input::-webkit-outer-spin-button,
.rpm-split-amount-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.rpm-split-hint {
  margin: 0;
  font-size: 12px !important;
  color: #6b7280;
  line-height: 1.6;
}

.rpm-split-total-amount {
  font-size: 14px !important;
  color: #374151;
}

.rpm-split-total-amount strong {
  font-weight: 700 !important;
  color: #111827;
}

/* ─── Footer ─── */
.rpm-footer {
  padding: 14px 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-shrink: 0;
  background: #fff;
}

/* "Print Bill and Pay" — sits beside the process button, matches its height */
.rpm-print-pay-btn {
  height: 46px;
  min-width: auto;
  padding: 0 20px;
}

.rpm-print-pay-btn:disabled {
  border-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
}

.rpm-process-btn {
  height: 46px;
  padding: 0 28px;
  border: 0;
  border-radius: 10px;
  background: #2563eb;
  color: #fff;
  font-size: 15px !important;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background 0.12s;
  white-space: nowrap;
}

.rpm-process-btn:hover:not(:disabled) {
  background: #1d4ed8;
}

.rpm-process-btn:disabled {
  background: #bfdbfe;
  cursor: not-allowed;
}

/* ─── Processing / Success / Manual screens ─── */
.rpm-processing-screen {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 28px;
  padding: 32px;
  min-height: 400px;
}

.rpm-processing-screen h3 {
  margin: 0;
  font-size: 20px !important;
  font-weight: 500;
  color: #111827;
}

.rpm-processing-dot {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #4f77e8;
  animation: rpmPulse 1.2s ease-in-out infinite;
}

.rpm-loader-gif {
  width: 110px;
  height: 110px;
}

.rpm-processing-actions,
.rpm-success-actions,
.rpm-success-footer {
  display: flex;
  gap: 14px;
}

.rpm-btn {
  border-radius: 10px;
  border: 1px solid #111827;
  background: #ffffff;
  color: #111827;
  min-width: 140px;
  height: 50px;
  padding: 0 16px;
  font-size: 14px !important;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.rpm-btn-danger {
  border-color: #ef4444;
  color: #dc2626;
}

.rpm-btn-outline {
  border-color: #111827;
}

.rpm-btn-dark {
  border: 0;
  background: #0f172a;
  color: #ffffff;
  min-width: 230px;
  height: 56px;
  border-radius: 14px;
  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.18);
}

.rpm-success-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 100%;
  padding: 32px 56px;
  text-align: center;
  background: radial-gradient(circle at top, rgba(16, 185, 129, 0.12), transparent 30%), #ffffff;
}

.rpm-success-icon-wrapper {
  width: 128px;
  height: 128px;
  margin-bottom: 24px;
  border-radius: 50%;
  background: #ecfdf5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rpm-success-icon-check {
  color: #10b981;
}

.rpm-success-check-svg {
  width: 64px;
  height: 64px;
}

.rpm-success-box h2 {
  margin: 0;
  font-size: 30px !important;
  line-height: 1.2;
  font-weight: 800;
  color: #0f172a;
}

.rpm-success-box p {
  margin: 0;
  color: #64748b;
}

.rpm-success-amount {
  font-size: 18px !important;
}

.rpm-success-method {
  margin-bottom: 4px !important;
  color: #047857 !important;
  font-size: 13px !important;
  font-weight: 700;
}

.rpm-success-actions {
  width: min(760px, 100%);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin: 10px 0 38px;
}

.rpm-success-action-btn {
  width: 100%;
  min-width: 0;
  height: 72px;
  flex-direction: column;
  gap: 8px;
  border-width: 2px;
  border-radius: 14px;
  font-weight: 800;
  transition:
    border-color 0.15s ease,
    background 0.15s ease,
    color 0.15s ease;
}

.rpm-success-action-btn:hover {
  border-color: #2563eb;
  background: rgba(37, 99, 235, 0.06);
  color: #2563eb;
}

.rpm-success-action-btn svg {
  font-size: 24px !important;
}

.rpm-manual-box {
  width: min(420px, 90%);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rpm-manual-box h3 {
  margin: 0 0 8px;
  font-size: 18px !important;
}

.rpm-manual-box label {
  font-size: 13px !important;
  color: #374151;
}

.rpm-primary-btn {
  margin-top: auto;
  height: 44px;
  border: 0;
  border-radius: 8px;
  background: #1d63da;
  color: #ffffff;
  font-size: 16px !important;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  padding: 0 20px;
}

.rpm-primary-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ─── Spinner (for charge loaders) ─── */
.rpm-extras-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid #e5e7eb;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: rpm-spin 0.7s linear infinite;
  flex-shrink: 0;
}

/* ─── Zero amount container ─── */
.rpm-zero-amount-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 32px;
  text-align: center;
}

.rpm-zero-amount-container h2 {
  margin: 0;
  font-size: 24px !important;
  font-weight: 700;
  color: #111827;
}

.rpm-zero-amount-container p {
  margin: 0;
  font-size: 14px !important;
  color: #6b7280;
}

/* ─── Animations ─── */
@keyframes rpmFadeIn {
  0% {
    opacity: 0;
    transform: translateX(24px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes rpmPulse {
  0% {
    transform: scale(0.85);
    opacity: 0.75;
  }
  100% {
    transform: scale(1.15);
    opacity: 1;
  }
}

@keyframes rpm-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ─── Bill Summary Panel ─── */
.rpm-bs-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.22);
}

.rpm-bs-panel {
  width: 480px;
  max-width: 92vw;
  max-height: 88vh;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);
  animation: rpmFadeIn 160ms ease-out;
}

.rpm-bs-header {
  background: linear-gradient(145deg, #1e3a8a 0%, #3b82f6 100%);
  padding: 20px 20px 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-shrink: 0;
  gap: 12px;
}

.rpm-bs-eyebrow {
  font-size: 11px !important;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  display: block;
  margin-bottom: 6px;
}

.rpm-bs-title {
  margin: 0 0 5px;
  font-size: 22px !important;
  font-weight: 700;
  color: #fff;
}

.rpm-bs-subtitle {
  margin: 0;
  font-size: 13px !important;
  color: rgba(255, 255, 255, 0.78);
}

.rpm-bs-close-btn {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 0;
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.12s;
}

.rpm-bs-close-btn:hover {
  background: rgba(255, 255, 255, 0.35);
}

/* Scrollable container for the card */
.rpm-bs-body {
  background: #f9fafb;
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

/* Card container matching bg-[#fffdf8] */
.rpm-bs-card {
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  background-color: #fffdf8;
  padding: 16px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

/* Receipt typography.
   The descendant selectors are required: index.css has a global
   \`* { font-family: "Outfit", ... }\`, and a directly-matched declaration always beats an
   inherited one — so setting the font on the containers alone would never reach the text.
   Generic \`monospace\` goes last so the named faces are actually reachable. */
.rpm-bs-receipt-top,
.rpm-bs-receipt-top *,
.rpm-bs-items-section,
.rpm-bs-items-section *,
.rpm-bs-summary-section,
.rpm-bs-summary-section * {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

/* Receipt Top */
.rpm-bs-receipt-top {
  border-bottom: 1px dashed #cbd5e1;
  padding-bottom: 12px;
  font-size: 12px;
  color: #334155;
}

.rpm-bs-receipt-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.rpm-bs-biz-name {
  font-weight: 600;
  color: #020617;
}

.rpm-bs-receipt-sub-row {
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #64748b;
}

/* Items section */
.rpm-bs-items-section {
  margin-top: 16px;
  font-size: 12px;
  color: #334155;
}

.rpm-bs-items-header-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 42px 88px;
  gap: 8px;
  border-bottom: 1px dashed #cbd5e1;
  padding-bottom: 8px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #94a3b8;
}

/* Set on the spans directly — HomePage.css has a global \`* { letter-spacing: normal }\`
   that would otherwise beat the tracking inherited from the grid above.
   Column alignment is defined here rather than borrowing \`.text-center\`/\`.text-right\`,
   which only exist in unrelated feature stylesheets. */
.rpm-bs-items-header-grid span {
  letter-spacing: 0.16em;
}

.rpm-bs-items-header-grid span:nth-child(2) {
  text-align: center;
}

.rpm-bs-items-header-grid span:nth-child(3) {
  text-align: right;
}

.rpm-bs-items-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 0;
}

.rpm-bs-item-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rpm-bs-item-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 42px 88px;
  gap: 8px;
}

/* Lets the name/note ellipsis engage instead of widening the column. */
.rpm-bs-item-main {
  min-width: 0;
}

.rpm-bs-addon-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 42px 88px;
  gap: 8px;
  align-items: baseline;
}

.rpm-bs-item-name {
  margin: 0;
  font-weight: 600;
  color: #020617;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rpm-bs-item-price-each {
  margin: 2px 0 0 0;
  font-size: 11px;
  color: #64748b;
}

.rpm-bs-item-addon-name {
  font-size: 11px;
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rpm-bs-item-addon-val {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  text-align: right;
}

.rpm-bs-item-note {
  margin: 2px 0 0 0;
  font-size: 11px;
  font-style: italic;
  color: #94a3b8;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.rpm-bs-item-qty {
  margin: 0;
  text-align: center;
  font-weight: 600;
  color: #475569;
}

.rpm-bs-item-val {
  margin: 0;
  text-align: right;
  font-weight: 600;
  color: #020617;
}

/* Summary section */
.rpm-bs-summary-section {
  border-top: 1px dashed #cbd5e1;
  padding-top: 12px;
  font-size: 12px;
}

.rpm-bs-summary-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rpm-bs-sum-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #334155;
}

.rpm-bs-sum-label {
  color: #64748b;
}

.rpm-bs-sum-value {
  font-weight: 600;
  color: #020617;
}

.rpm-bs-sum-value.negative {
  color: #e11d48;
}

.rpm-bs-divider-total {
  margin-top: 12px;
  border-top: 1px dashed #cbd5e1;
  padding-top: 12px;
}

.rpm-bs-total-area {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rpm-bs-grand-total-card {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  border-radius: 16px;
  background-color: #020617;
  padding: 12px 14px;
  color: #ffffff;
}

.rpm-bs-gt-title {
  margin: 0;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: rgba(255, 255, 255, 0.5);
}

.rpm-bs-gt-subtitle {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.rpm-bs-gt-amount-text {
  margin: 0;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: -0.025em;
}

/* The total card is a display element, not receipt text — keep it in the UI face so the
   heavy weight and tight tracking above render as intended. Must come after the
   \`.rpm-bs-summary-section *\` monospace rule to win at equal specificity. */
.rpm-bs-grand-total-card,
.rpm-bs-grand-total-card * {
  font-family: "Outfit", "Inter", sans-serif;
}

/* ─── Responsive ─── */
@media (max-width: 900px) {
  .rpm-drawer-paper {
    width: 100vw;
    max-width: 100vw;
  }

  .rpm-shell {
    height: 100vh;
    margin: 0;
    border-radius: 0;
  }

  .rpm-body {
    grid-template-columns: 1fr;
  }

  .rpm-tender-panel {
    border-right: 0;
    border-bottom: 1px solid #e5e7eb;
  }

  .rpm-split-panels {
    grid-template-columns: 1fr;
  }

  .rpm-tender-name {
    font-size: 22px !important;
  }

  .rpm-manual-charges-fields {
    flex-direction: column;
  }

  .rpm-success-box {
    padding: 28px;
  }

  .rpm-success-actions {
    width: min(520px, 100%);
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/paymentModal/restaurantPaymentModal.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,WAAW;EACX,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,+CAA+C;AAC/C;EACE,uBAAuB;EACvB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd;;;eAGa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,8BAA8B;EAC9B,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,yDAA0L;EAC1L,4BAA4B;EAC5B,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,8EAA8E;AAC9E;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,8FAA8F;AAChG;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB;;;oBAGkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,6DAA6D;EAC7D,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;EACnB,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,kDAAkD;AACpD;;AAEA;;;;6EAI6E;AAC7E;;;;;;EAME,6EAA6E;AAC/E;;AAEA,gBAAgB;AAChB;EACE,iCAAiC;EACjC,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,QAAQ;EACR,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;;uDAGuD;AACvD;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,QAAQ;AACV;;AAEA,uEAAuE;AACvE;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;4EAE4E;AAC5E;;EAEE,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* ─── Shell (centered modal) ─── */\n.rpm-drawer-paper {\n  width: 80vw;\n  background: transparent !important;\n  box-shadow: none !important;\n  overflow: visible !important;\n  border-radius: 0 !important;\n  z-index: 2001;\n}\n\n.rpm-shell {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  margin: 0;\n  background: #ffffff;\n  border-radius: 0;\n  box-shadow: -4px 0 32px rgba(15, 23, 42, 0.18);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: rpmFadeIn 180ms ease-out;\n}\n\n/* ─── Header ─── */\n.rpm-header {\n  padding: 18px 24px 14px;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n}\n\n.rpm-header-left h3 {\n  margin: 0;\n  font-size: 22px !important;\n  font-weight: 700;\n  color: #101828;\n  line-height: 1.2;\n}\n\n.rpm-header-left p {\n  margin: 4px 0 0;\n  color: #6b7280;\n  font-size: 13px !important;\n}\n\n.rpm-header-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.rpm-bill-summary-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  background: #fff;\n  color: #334155;\n  font-size: 14px !important;\n  font-weight: 600;\n  padding: 0 14px;\n  cursor: pointer;\n  height: 44px;\n  white-space: nowrap;\n  transition: all 0.15s;\n}\n\n.rpm-bill-summary-btn:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n}\n\n/* ─── Extras top section ─── */\n.rpm-extras-top {\n  padding: 12px 24px;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.rpm-extras-toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 44px;\n  white-space: nowrap;\n  padding: 0 14px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #334155;\n  font-size: 14px !important;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.rpm-extras-toggle-btn:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n}\n\n.rpm-manual-charges {\n  margin-top: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 16px;\n  background: #fafafa;\n}\n\n.rpm-charges-apply-row {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.rpm-charges-cancel-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 36px;\n  padding: 0 20px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #334155;\n  font-size: 13px !important;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.rpm-charges-cancel-btn:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n}\n\n.rpm-charges-cancel-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.rpm-charges-apply-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 36px;\n  padding: 0 20px;\n  border-radius: 8px;\n  border: 0;\n  background: #2563eb;\n  color: #fff;\n  font-size: 13px !important;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.rpm-charges-apply-btn:hover {\n  background: #1d4ed8;\n}\n\n.rpm-charges-apply-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.rpm-manual-charges-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 14px;\n  gap: 16px;\n}\n\n.rpm-manual-charges-title {\n  font-size: 11px !important;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.rpm-manual-charges-info p {\n  margin: 0;\n  font-size: 12px !important;\n  color: #6b7280;\n}\n\n.rpm-charges-total-badge {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 6px 12px;\n  text-align: right;\n  background: #fff;\n  flex-shrink: 0;\n}\n\n.rpm-charges-total-badge span {\n  display: block;\n  font-size: 10px !important;\n  font-weight: 700;\n  color: #2563eb;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.rpm-charges-total-value {\n  font-size: 18px !important;\n  font-weight: 700;\n  color: #2563eb;\n  display: block;\n}\n\n.rpm-manual-charges-fields {\n  display: flex;\n  gap: 16px;\n}\n\n.rpm-charge-field {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.rpm-charge-field label {\n  font-size: 13px !important;\n  color: #374151;\n  font-weight: 500;\n}\n\n.rpm-charge-input-wrap {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  position: relative;\n}\n\n.rpm-charge-input {\n  width: 100%;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 14px !important;\n  color: #111827;\n  outline: none;\n  background: #fff;\n}\n\n.rpm-charge-input:focus {\n  border-color: #3b82f6;\n}\n\n.rpm-charge-input::-webkit-outer-spin-button,\n.rpm-charge-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n\n/* ─── Payment Methods (horizontal cards) ─── */\n.rpm-methods-section {\n  padding: 14px 24px 10px;\n  flex-shrink: 0;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.rpm-methods-label {\n  font-size: 11px !important;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  display: block;\n}\n\n.rpm-methods-row {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n}\n\n.rpm-methods-row::-webkit-scrollbar {\n  height: 3px;\n}\n\n.rpm-methods-row::-webkit-scrollbar-thumb {\n  background: #e5e7eb;\n  border-radius: 2px;\n}\n\n.rpm-method-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-width: 88px;\n  padding: 12px 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 12px !important;\n  font-weight: 500;\n  color: #374151;\n  flex-shrink: 0;\n  transition:\n    background 0.12s,\n    border-color 0.12s,\n    color 0.12s;\n}\n\n.rpm-method-card.active {\n  background: #111827;\n  border-color: #111827;\n  color: #ffffff;\n}\n\n.rpm-method-card:hover:not(.active) {\n  background: #f3f4f6;\n}\n\n/* ─── Body (normal mode, two columns) ─── */\n.rpm-body {\n  display: grid;\n  grid-template-columns: 46% 54%;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* ─── Active Tender panel (left) ─── */\n.rpm-tender-panel {\n  padding: 20px;\n  border-right: 1px solid #e5e7eb;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background: #fafbfc;\n  overflow-y: auto;\n}\n\n.rpm-tender-label {\n  font-size: 11px !important;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.rpm-tender-title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.rpm-tender-name {\n  margin: 0;\n  font-size: 28px !important;\n  font-weight: 700;\n  color: #111827;\n}\n\n.rpm-terminal-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  background: #ecfdf5;\n  border: 1px solid #6ee7b7;\n  border-radius: 999px;\n  font-size: 11px !important;\n  font-weight: 700;\n  color: #065f46;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.rpm-terminal-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #10b981;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n.rpm-tender-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.rpm-stat-box {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 10px 12px;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.rpm-stat-label {\n  font-size: 10px !important;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.rpm-stat-value {\n  font-size: 17px !important;\n  font-weight: 700;\n  color: #111827;\n}\n\n.rpm-remaining-red {\n  color: #dc2626 !important;\n}\n\n.rpm-settlement-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 24px;\n  padding: 20px;\n  background: #f8fafc;\n  transition: all 0.15s ease-in-out;\n  display: flex;\n  flex-direction: column;\n  margin-top: auto;\n}\n\n.rpm-settlement-card-change {\n  border-color: #a4f4cf;\n  background: #ecfdf5;\n}\n\n.rpm-settlement-card-change .rpm-settlement-label {\n  color: #007a55;\n}\n\n.rpm-settlement-card-change .rpm-settlement-amount {\n  color: #007a55;\n}\n\n.rpm-settlement-label {\n  font-size: 11px !important;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.rpm-settlement-body {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.rpm-settlement-text {\n  font-size: 13px !important;\n  color: #6b7280;\n  display: block;\n  margin-top: 4px;\n}\n\n.rpm-settlement-amount {\n  font-size: 30px !important;\n  font-weight: 700;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n\n/* ─── Action panel (right) ─── */\n.rpm-action-panel {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  overflow-y: auto;\n  background: #fff;\n}\n\n/* Cash input */\n.rpm-cash-label {\n  font-size: 13px !important;\n  font-weight: 500;\n  color: #374151;\n  display: block;\n}\n\n.rpm-cash-input-wrapper {\n  display: flex;\n  align-items: center;\n  border: 2px solid #3b82f6;\n  border-radius: 10px;\n  padding: 0 14px;\n  background: #fff;\n  height: 54px;\n}\n\n.rpm-cash-currency {\n  font-size: 20px !important;\n  color: #374151;\n  margin-right: 8px;\n  font-weight: 500;\n}\n\n.rpm-cash-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 22px !important;\n  font-weight: 600;\n  color: #111827;\n  background: transparent;\n  width: 100%;\n}\n\n.rpm-cash-input::-webkit-inner-spin-button,\n.rpm-cash-input::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n}\n\n.rpm-quick-chips {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.rpm-quick-chip {\n  border: 1px solid #e5e7eb;\n  border-radius: 999px;\n  background: #fff;\n  color: #374151;\n  font-size: 13px !important;\n  font-weight: 500;\n  padding: 6px 14px;\n  cursor: pointer;\n  transition: background 0.1s;\n}\n\n.rpm-quick-chip:hover {\n  background: #f3f4f6;\n}\n\n.rpm-exact-chip {\n  border-color: #3b82f6;\n  color: #2563eb;\n  font-weight: 600;\n}\n\n.rpm-exact-chip:hover {\n  background: #eff6ff;\n}\n\n/* Ready to process (card / upi) */\n.rpm-ready-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.rpm-ready-label {\n  font-size: 11px !important;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.rpm-ready-method-name {\n  font-size: 26px !important;\n  font-weight: 700;\n  color: #111827;\n}\n\n.rpm-ready-amount-box {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 14px 16px;\n  background: #f9fafb;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.rpm-ready-amount-label {\n  font-size: 10px !important;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.rpm-ready-amount-value {\n  font-size: 26px !important;\n  font-weight: 700;\n  color: #111827;\n}\n\n.rpm-ready-desc {\n  margin: 0;\n  font-size: 13px !important;\n  color: #6b7280;\n}\n\n/* ─── Split mode ─── */\n.rpm-split-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.rpm-split-mode-tabs {\n  display: flex;\n  padding: 12px 20px 0;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.rpm-split-mode-tab {\n  padding: 10px 20px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  font-size: 14px !important;\n  font-weight: 500;\n  color: #6b7280;\n  cursor: pointer;\n  transition: background 0.12s;\n}\n\n.rpm-split-mode-tab.active {\n  background: #111827;\n  border-color: #111827;\n  color: #fff;\n  font-weight: 600;\n}\n\n.rpm-split-cancel-btn {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border: 1px solid #fca5a5;\n  border-radius: 8px;\n  background: #fff5f5;\n  color: #b91c1c;\n  font-size: 13px !important;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.12s;\n}\n\n.rpm-split-cancel-btn:hover:not(:disabled) {\n  background: #fee2e2;\n}\n\n.rpm-split-cancel-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.rpm-split-panels {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  padding: 12px 20px 0;\n  gap: 12px;\n}\n\n.rpm-split-captured-panel {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  overflow-y: auto;\n}\n\n.rpm-split-captured-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.rpm-split-captured-info strong {\n  font-size: 15px !important;\n  color: #111827;\n  display: block;\n}\n\n.rpm-split-captured-info p {\n  margin: 4px 0 0;\n  font-size: 12px !important;\n  color: #6b7280;\n}\n\n.rpm-split-count {\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.rpm-split-count-num {\n  display: block;\n  font-size: 22px !important;\n  font-weight: 700;\n  color: #111827;\n}\n\n.rpm-split-count-label {\n  font-size: 10px !important;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.rpm-split-captured-body {\n  flex: 1;\n}\n\n.rpm-split-empty-msg {\n  font-size: 13px !important;\n  color: #6b7280;\n  border: 1px dashed #e5e7eb;\n  border-radius: 8px;\n  padding: 20px 16px;\n  text-align: center;\n  margin: 0;\n}\n\n.rpm-split-payment-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px !important;\n  font-weight: 600;\n  color: #111827;\n  padding: 10px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.rpm-split-next-panel {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  overflow-y: auto;\n}\n\n.rpm-split-next-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.rpm-split-next-info strong {\n  font-size: 15px !important;\n  color: #111827;\n  display: block;\n}\n\n.rpm-split-next-info p {\n  margin: 4px 0 0;\n  font-size: 12px !important;\n  color: #6b7280;\n}\n\n.rpm-use-remaining-btn {\n  flex-shrink: 0;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  color: #374151;\n  font-size: 11px !important;\n  font-weight: 700;\n  padding: 6px 10px;\n  cursor: pointer;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n}\n\n.rpm-use-remaining-btn:hover {\n  background: #f3f4f6;\n}\n\n.rpm-split-next-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.rpm-split-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.rpm-split-field label {\n  font-size: 12px !important;\n  font-weight: 600;\n  color: #374151;\n}\n\n.rpm-split-select {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 9px 30px 9px 12px;\n  font-size: 13px !important;\n  color: #111827;\n  background: #fff;\n  outline: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  width: 100%;\n}\n\n.rpm-split-select:focus {\n  border-color: #3b82f6;\n}\n\n.rpm-split-amount-input {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 9px 12px;\n  font-size: 14px !important;\n  font-weight: 600;\n  color: #111827;\n  background: #fff;\n  outline: none;\n  width: 100%;\n}\n\n.rpm-split-amount-input:focus {\n  border-color: #3b82f6;\n}\n\n.rpm-split-amount-input::-webkit-outer-spin-button,\n.rpm-split-amount-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n\n.rpm-split-hint {\n  margin: 0;\n  font-size: 12px !important;\n  color: #6b7280;\n  line-height: 1.6;\n}\n\n.rpm-split-total-amount {\n  font-size: 14px !important;\n  color: #374151;\n}\n\n.rpm-split-total-amount strong {\n  font-weight: 700 !important;\n  color: #111827;\n}\n\n/* ─── Footer ─── */\n.rpm-footer {\n  padding: 14px 24px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-shrink: 0;\n  background: #fff;\n}\n\n/* \"Print Bill and Pay\" — sits beside the process button, matches its height */\n.rpm-print-pay-btn {\n  height: 46px;\n  min-width: auto;\n  padding: 0 20px;\n}\n\n.rpm-print-pay-btn:disabled {\n  border-color: #d1d5db;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.rpm-process-btn {\n  height: 46px;\n  padding: 0 28px;\n  border: 0;\n  border-radius: 10px;\n  background: #2563eb;\n  color: #fff;\n  font-size: 15px !important;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: background 0.12s;\n  white-space: nowrap;\n}\n\n.rpm-process-btn:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.rpm-process-btn:disabled {\n  background: #bfdbfe;\n  cursor: not-allowed;\n}\n\n/* ─── Processing / Success / Manual screens ─── */\n.rpm-processing-screen {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 28px;\n  padding: 32px;\n  min-height: 400px;\n}\n\n.rpm-processing-screen h3 {\n  margin: 0;\n  font-size: 20px !important;\n  font-weight: 500;\n  color: #111827;\n}\n\n.rpm-processing-dot {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: #4f77e8;\n  animation: rpmPulse 1.2s ease-in-out infinite;\n}\n\n.rpm-loader-gif {\n  width: 110px;\n  height: 110px;\n}\n\n.rpm-processing-actions,\n.rpm-success-actions,\n.rpm-success-footer {\n  display: flex;\n  gap: 14px;\n}\n\n.rpm-btn {\n  border-radius: 10px;\n  border: 1px solid #111827;\n  background: #ffffff;\n  color: #111827;\n  min-width: 140px;\n  height: 50px;\n  padding: 0 16px;\n  font-size: 14px !important;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.rpm-btn-danger {\n  border-color: #ef4444;\n  color: #dc2626;\n}\n\n.rpm-btn-outline {\n  border-color: #111827;\n}\n\n.rpm-btn-dark {\n  border: 0;\n  background: #0f172a;\n  color: #ffffff;\n  min-width: 230px;\n  height: 56px;\n  border-radius: 14px;\n  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.18);\n}\n\n.rpm-success-box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-height: 100%;\n  padding: 32px 56px;\n  text-align: center;\n  background: radial-gradient(circle at top, rgba(16, 185, 129, 0.12), transparent 30%), #ffffff;\n}\n\n.rpm-success-icon-wrapper {\n  width: 128px;\n  height: 128px;\n  margin-bottom: 24px;\n  border-radius: 50%;\n  background: #ecfdf5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rpm-success-icon-check {\n  color: #10b981;\n}\n\n.rpm-success-check-svg {\n  width: 64px;\n  height: 64px;\n}\n\n.rpm-success-box h2 {\n  margin: 0;\n  font-size: 30px !important;\n  line-height: 1.2;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.rpm-success-box p {\n  margin: 0;\n  color: #64748b;\n}\n\n.rpm-success-amount {\n  font-size: 18px !important;\n}\n\n.rpm-success-method {\n  margin-bottom: 4px !important;\n  color: #047857 !important;\n  font-size: 13px !important;\n  font-weight: 700;\n}\n\n.rpm-success-actions {\n  width: min(760px, 100%);\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n  margin: 10px 0 38px;\n}\n\n.rpm-success-action-btn {\n  width: 100%;\n  min-width: 0;\n  height: 72px;\n  flex-direction: column;\n  gap: 8px;\n  border-width: 2px;\n  border-radius: 14px;\n  font-weight: 800;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease,\n    color 0.15s ease;\n}\n\n.rpm-success-action-btn:hover {\n  border-color: #2563eb;\n  background: rgba(37, 99, 235, 0.06);\n  color: #2563eb;\n}\n\n.rpm-success-action-btn svg {\n  font-size: 24px !important;\n}\n\n.rpm-manual-box {\n  width: min(420px, 90%);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.rpm-manual-box h3 {\n  margin: 0 0 8px;\n  font-size: 18px !important;\n}\n\n.rpm-manual-box label {\n  font-size: 13px !important;\n  color: #374151;\n}\n\n.rpm-primary-btn {\n  margin-top: auto;\n  height: 44px;\n  border: 0;\n  border-radius: 8px;\n  background: #1d63da;\n  color: #ffffff;\n  font-size: 16px !important;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 0 20px;\n}\n\n.rpm-primary-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ─── Spinner (for charge loaders) ─── */\n.rpm-extras-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #e5e7eb;\n  border-top-color: #3b82f6;\n  border-radius: 50%;\n  animation: rpm-spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n\n/* ─── Zero amount container ─── */\n.rpm-zero-amount-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 32px;\n  text-align: center;\n}\n\n.rpm-zero-amount-container h2 {\n  margin: 0;\n  font-size: 24px !important;\n  font-weight: 700;\n  color: #111827;\n}\n\n.rpm-zero-amount-container p {\n  margin: 0;\n  font-size: 14px !important;\n  color: #6b7280;\n}\n\n/* ─── Animations ─── */\n@keyframes rpmFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateX(24px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes rpmPulse {\n  0% {\n    transform: scale(0.85);\n    opacity: 0.75;\n  }\n  100% {\n    transform: scale(1.15);\n    opacity: 1;\n  }\n}\n\n@keyframes rpm-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ─── Bill Summary Panel ─── */\n.rpm-bs-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.22);\n}\n\n.rpm-bs-panel {\n  width: 480px;\n  max-width: 92vw;\n  max-height: 88vh;\n  border-radius: 16px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);\n  animation: rpmFadeIn 160ms ease-out;\n}\n\n.rpm-bs-header {\n  background: linear-gradient(145deg, #1e3a8a 0%, #3b82f6 100%);\n  padding: 20px 20px 20px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-shrink: 0;\n  gap: 12px;\n}\n\n.rpm-bs-eyebrow {\n  font-size: 11px !important;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.7);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  display: block;\n  margin-bottom: 6px;\n}\n\n.rpm-bs-title {\n  margin: 0 0 5px;\n  font-size: 22px !important;\n  font-weight: 700;\n  color: #fff;\n}\n\n.rpm-bs-subtitle {\n  margin: 0;\n  font-size: 13px !important;\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.rpm-bs-close-btn {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 0;\n  background: rgba(255, 255, 255, 0.22);\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background 0.12s;\n}\n\n.rpm-bs-close-btn:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n/* Scrollable container for the card */\n.rpm-bs-body {\n  background: #f9fafb;\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n/* Card container matching bg-[#fffdf8] */\n.rpm-bs-card {\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  background-color: #fffdf8;\n  padding: 16px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n/* Receipt typography.\n   The descendant selectors are required: index.css has a global\n   `* { font-family: \"Outfit\", ... }`, and a directly-matched declaration always beats an\n   inherited one — so setting the font on the containers alone would never reach the text.\n   Generic `monospace` goes last so the named faces are actually reachable. */\n.rpm-bs-receipt-top,\n.rpm-bs-receipt-top *,\n.rpm-bs-items-section,\n.rpm-bs-items-section *,\n.rpm-bs-summary-section,\n.rpm-bs-summary-section * {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n}\n\n/* Receipt Top */\n.rpm-bs-receipt-top {\n  border-bottom: 1px dashed #cbd5e1;\n  padding-bottom: 12px;\n  font-size: 12px;\n  color: #334155;\n}\n\n.rpm-bs-receipt-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.rpm-bs-biz-name {\n  font-weight: 600;\n  color: #020617;\n}\n\n.rpm-bs-receipt-sub-row {\n  margin-top: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  color: #64748b;\n}\n\n/* Items section */\n.rpm-bs-items-section {\n  margin-top: 16px;\n  font-size: 12px;\n  color: #334155;\n}\n\n.rpm-bs-items-header-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 42px 88px;\n  gap: 8px;\n  border-bottom: 1px dashed #cbd5e1;\n  padding-bottom: 8px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #94a3b8;\n}\n\n/* Set on the spans directly — HomePage.css has a global `* { letter-spacing: normal }`\n   that would otherwise beat the tracking inherited from the grid above.\n   Column alignment is defined here rather than borrowing `.text-center`/`.text-right`,\n   which only exist in unrelated feature stylesheets. */\n.rpm-bs-items-header-grid span {\n  letter-spacing: 0.16em;\n}\n\n.rpm-bs-items-header-grid span:nth-child(2) {\n  text-align: center;\n}\n\n.rpm-bs-items-header-grid span:nth-child(3) {\n  text-align: right;\n}\n\n.rpm-bs-items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 12px 0;\n}\n\n.rpm-bs-item-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.rpm-bs-item-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 42px 88px;\n  gap: 8px;\n}\n\n/* Lets the name/note ellipsis engage instead of widening the column. */\n.rpm-bs-item-main {\n  min-width: 0;\n}\n\n.rpm-bs-addon-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 42px 88px;\n  gap: 8px;\n  align-items: baseline;\n}\n\n.rpm-bs-item-name {\n  margin: 0;\n  font-weight: 600;\n  color: #020617;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rpm-bs-item-price-each {\n  margin: 2px 0 0 0;\n  font-size: 11px;\n  color: #64748b;\n}\n\n.rpm-bs-item-addon-name {\n  font-size: 11px;\n  color: #64748b;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rpm-bs-item-addon-val {\n  font-size: 11px;\n  font-weight: 500;\n  color: #64748b;\n  text-align: right;\n}\n\n.rpm-bs-item-note {\n  margin: 2px 0 0 0;\n  font-size: 11px;\n  font-style: italic;\n  color: #94a3b8;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.rpm-bs-item-qty {\n  margin: 0;\n  text-align: center;\n  font-weight: 600;\n  color: #475569;\n}\n\n.rpm-bs-item-val {\n  margin: 0;\n  text-align: right;\n  font-weight: 600;\n  color: #020617;\n}\n\n/* Summary section */\n.rpm-bs-summary-section {\n  border-top: 1px dashed #cbd5e1;\n  padding-top: 12px;\n  font-size: 12px;\n}\n\n.rpm-bs-summary-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.rpm-bs-sum-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  color: #334155;\n}\n\n.rpm-bs-sum-label {\n  color: #64748b;\n}\n\n.rpm-bs-sum-value {\n  font-weight: 600;\n  color: #020617;\n}\n\n.rpm-bs-sum-value.negative {\n  color: #e11d48;\n}\n\n.rpm-bs-divider-total {\n  margin-top: 12px;\n  border-top: 1px dashed #cbd5e1;\n  padding-top: 12px;\n}\n\n.rpm-bs-total-area {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.rpm-bs-grand-total-card {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n  border-radius: 16px;\n  background-color: #020617;\n  padding: 12px 14px;\n  color: #ffffff;\n}\n\n.rpm-bs-gt-title {\n  margin: 0;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.rpm-bs-gt-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.rpm-bs-gt-amount-text {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 900;\n  letter-spacing: -0.025em;\n}\n\n/* The total card is a display element, not receipt text — keep it in the UI face so the\n   heavy weight and tight tracking above render as intended. Must come after the\n   `.rpm-bs-summary-section *` monospace rule to win at equal specificity. */\n.rpm-bs-grand-total-card,\n.rpm-bs-grand-total-card * {\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\n/* ─── Responsive ─── */\n@media (max-width: 900px) {\n  .rpm-drawer-paper {\n    width: 100vw;\n    max-width: 100vw;\n  }\n\n  .rpm-shell {\n    height: 100vh;\n    margin: 0;\n    border-radius: 0;\n  }\n\n  .rpm-body {\n    grid-template-columns: 1fr;\n  }\n\n  .rpm-tender-panel {\n    border-right: 0;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  .rpm-split-panels {\n    grid-template-columns: 1fr;\n  }\n\n  .rpm-tender-name {\n    font-size: 22px !important;\n  }\n\n  .rpm-manual-charges-fields {\n    flex-direction: column;\n  }\n\n  .rpm-success-box {\n    padding: 28px;\n  }\n\n  .rpm-success-actions {\n    width: min(520px, 100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
